import { UpdatePublishSettings } from '@/connection/settings/update-publish-settings';
import { ProjectStateReducerCreator } from '../types';

const updatePublishSettingsReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ project_uuid, isLocked, dmaId }: { project_uuid: string; isLocked?: boolean; dmaId?: string }) => {
      try {
        const result = await UpdatePublishSettings(project_uuid, isLocked, dmaId);

        return result;
      } catch (e) {
        console.error(e);
      }
    },
    {
      pending: (state) => {
        if (state.workingProject) {
          state.isSettingsUpdating = true;
        }
      },
      fulfilled: (state, action) => {
        if (state.workingProject && action.payload) {
          state.workingProject.dma_id = action.payload?.dma_id;
          state.workingProject.is_publish_locked = action.payload?.is_publish_locked;
          state.isSettingsUpdating = false;
        }
      },
      rejected: (state) => {
        state.isSettingsUpdating = false;
      },
    }
  );
};

export default updatePublishSettingsReducer;
